import React from 'react';
import SystemsViewScaffold, { ComingSoonBody } from './SystemsViewScaffold';

/**
 * Phase 4 — Toimijakartta (stakeholder / actor map).
 * Actors from the organisations model, sized/typed by relationship, linked to the
 * solutions they lead/support. Persons CAN be included (the workshop has them),
 * but the organisations layer is deliberately GDPR-clean — person-level nodes
 * need consent + a separate decision before they ship. Org-level first.
 */
export default function ActorMapScreen() {
  return (
    <SystemsViewScaffold viewKey="actorMap">
      <ComingSoonBody>
        <p>
          Toimijoiden ja organisaatioiden vaikutussuhteet ja kytkennät ratkaisuihin
          (kuka johtaa / tukee / neuvoo). Lähtee organisaatiotasosta, joka on
          tietoisesti GDPR-puhdas.
        </p>
        <p style={{ color: '#FFD93D' }}>
          Huom: työpajassa on käytettävissä myös henkilötaso. Henkilösolmut ovat
          mahdollisia, mutta vaativat suostumuksen ja erillisen päätöksen ennen
          käyttöönottoa — ei oletuksena.
        </p>
      </ComingSoonBody>
    </SystemsViewScaffold>
  );
}
